/*** Choose Diamond Function Start ***/
$(document).on("click", ".tps-choose-this-diamond", function() {
  jQuery("#tps_choose_this_diamond").addClass('tps-loading');
  var diamond_certificate = $(this).data("certificate");
  var diamond_id = $(this).data("id");
  
  if(jQuery(this).data('reset-steps')){
    localStorage.removeItem("ring-selected-diamond");  
    localStorage.removeItem("ring-selected-setting");  
  }
  var productSku = []; 
  var proceedFlag = 1;

  //check diamond product already in cart or not
  jQuery.getJSON('/cart.js', function(cart) {
    if(cart.items != ''){ 
      
      $(cart.items).each(function(index, value) { 
         var str = "-";   
         var sku = value.sku;

         if(sku.indexOf(str) != -1){                  
           var str2 = "D";
           if(sku.indexOf(str2) != -1){
             sku = sku.split('-');
             var dia_cert = sku[0]; 
             dia_cert = dia_cert.replace("D","");
             sku = dia_cert;
           }else{
             sku = sku; 
           }                      
         }else{
           var sku = value.sku;      
         }

         productSku.push(sku);     
   
         setTimeout(function(){ 
           if($.inArray(diamond_certificate, productSku)!=(-1)){ 
             $('#tps_choose_this_diamond').removeClass('tps-loading');
             proceedFlag = 0;
             event.preventDefault();            
             alert(translations.titleDiamondProductAlreadyInCart);            
           } 
          }, 50); 
       });       
    }
  });

  var diamond = [{
      "diamond_id": $(this).data("id"),
      "diamond_shape": $(this).data("shape"),
      "diamond_price": $(this).data("price"),
      "diamond_formatted_price": $(this).data("formatted-price"),
      "diamond_title": $(this).data("name"),
      "diamond_type": $(this).data("type"),
      "diamond_sub_type": $(this).data("sub-type"),
      "diamond_carat" : $(this).data("carat"),
      "diamond_certificate" : $(this).data("certificate"),
      "diamond_image": $(this).data("image"),
  }];
  
  setTimeout(function(){  
    if(proceedFlag == 1){         
      localStorage.setItem("ring-selected-diamond", JSON.stringify(diamond));
      setSteps("diamond");
      $('#tps_choose_this_diamond').removeClass('tps-loading');
    }     
  }, 800);
  
});
/*** Choose Diamond Function End ***/

/******* Choose Setting function start ******/
$(document).on("click", ".tps-choose-this-setting", function() { 
  if(!$(".hulk_dropdown_hidden_prop").val()){
    alert(translations.titleRingSizeValidation);
    return false;
  }
  
  $("#tps_choose_this_setting").addClass("tps-loading");
  var selected_diamond = localStorage.getItem("ring-selected-diamond");

  if(selected_diamond != null || selected_diamond != undefined){
    var ring_selected_shape = $("#setting_center_stone").val();
    selected_diamond = JSON.parse(selected_diamond);
    var diamond_shape = selected_diamond[0].diamond_shape;
    var diamond_title = selected_diamond[0].diamond_title;

    if(diamond_shape != ring_selected_shape){     
      alert(translations.titleSelectedRingSetting+""+diamond_title+""+translations.titleChangeYourDiamondOrRing);     
      
      $("#tps_choose_this_setting").removeClass("tps-loading");
      return false;
    }    
  }  
  
  var setting = [{
      "product_id": $("#product_id").val(),
      "product_handle": $("#product_handle").val(),
      "product_title": $("#product_title").val(),
      "product_url": $("#product_url").val(),
      "setting_id": $("#setting_id").val(),
      "setting_sku": $("#setting_sku").val(),
      "setting_price": $("#setting_price").val(),
      "setting_formatted_price": $("#setting_formatted_price").val(),    
      "setting_metal": $("#setting_metal").val(),
      "setting_center_stone": $("#setting_center_stone").val(),
      "setting_can_be_match_with": $("#setting_can_be_match_with").val(),
      "setting_image": $("#setting_image").val(),
      "setting_description": $("#setting_description").val(),
      "setting_ring_size": $(".hulk_dropdown_hidden_prop").val(),
  }];
  localStorage.setItem("ring-selected-setting", JSON.stringify(setting));
  setTimeout(function(){
    $("#tps_choose_this_setting").removeClass("tps-loading");  
  }, 5000);  
  setSteps("setting");
});

/*** Set Currenct Step And Redirect To Next Step Start ****/
function setSteps(current_step) {
    var setp1 = "diamond";
    var setp2 = "setting";
    var setp3 = "final-ring";
  
    var ring_selected_diamond = localStorage.getItem("ring-selected-diamond"); 
    var ring_selected_setting = localStorage.getItem("ring-selected-setting"); 

    var diamond_info = JSON.parse(ring_selected_diamond);
    var setting_info = JSON.parse(ring_selected_setting);
  
    if (ring_selected_setting && ring_selected_diamond) {
        var setp3 = "final-ring";        
        
      	var diamond_price = (diamond_info[0].diamond_price);      	    
        var final_price = parseInt(setting_info[0].setting_price/100) + diamond_price; 
        // localStorage.setItem("final_ring_price", final_price);
        
        var diamond_id = diamond_info[0].diamond_id;
        var setting_id = setting_info[0].product_handle;
        var varient_id = setting_info[0].setting_id;
        var diamond_type = diamond_info[0].diamond_type;  
        window.location.href = tps_config.urls.final_ring+"?products="+diamond_id+"/"+setting_id+"/"+varient_id+"/"+diamond_type; // "/pages/final-pendant";

    } else if (current_step == "diamond" && ring_selected_setting) {
        var setp2 = "diamond";
        window.location.href = tps_config.urls.final_ring; // "/pages/final-ring"; 
    } else if (current_step == "setting" && ring_selected_diamond) {
        var setp2 = "setting";
        window.location.href = tps_config.urls.final_ring; //"/pages/final-ring"; 
    } else if (current_step == "diamond" && !ring_selected_setting) {
        var setp1 = "diamond";
        var setp2 = "setting";

        window.location.href = tps_config.urls.setting_listing;
    } else if (current_step == "setting" && !ring_selected_diamond) {
      	var setp1 = "setting";
        var setp2 = "diamond";
        window.location.href = tps_config.urls.loose_diamond;
    }

    var steps = [{
      "step1": setp1,
      "step2": setp2,
      "step3": setp3,
    }];
    var session_steps = localStorage.getItem("ringbuilder-steps");
    if(session_steps == null){
      localStorage.setItem("ringbuilder-steps", JSON.stringify(steps));
    }
}
/*** Set Currenct Step And Redirect To Next Step End ****/

 $(document).ready(function() {         
      /*** set last updated timestamp of product collection if local storage has 1 hour old product collection then clear collection ****/
      if (localStorage.getItem("ringbuilder-last-updated")) {
          var d1 = new Date();
          var d2 = new Date(localStorage.getItem("ringbuilder-last-updated"));
          var diff = parseInt(((d1 - d2) / 1000).toString());
          if (diff > 3600) {
              localStorage.clear();
              localStorage.setItem("ringbuilder-last-updated", d1);
          }
      } else {
          localStorage.setItem("ringbuilder-last-updated", new Date());
      }

      /**** set steps and render steps data start *****/
      var active = '';      
      var session_steps = localStorage.getItem("ringbuilder-steps");     
   
      if(session_steps == null){
        if((window.location.pathname.indexOf('/products/') == 0 || window.location.pathname.indexOf('/collections/') == 0)){
            active = "setting";              
            changeStepFlow();
        }else if(window.location.pathname.indexOf('/pages/') == 0){
            active = "diamond";            
        }        
      }else if(session_steps != null){
        session_steps = JSON.parse(session_steps);
        if (window.location.pathname.indexOf('final-engagement-ring') > -1) {
            active = "final"; 
            setStepDetails(active);
            if(session_steps[0]['step1'] == "setting"){
              changeStepFlow();
            }              
        }else if(session_steps[0]['step1'] == "diamond"){
            if(window.location.pathname.indexOf('/pages/') == 0){
              active = "diamond";
            }else if (window.location.pathname.indexOf('/products/') == 0 || window.location.pathname.indexOf('/collections/') == 0) {
              active = "setting";
            }            
            setStepDetails(active);
        }else if(session_steps[0]['step1'] == "setting"){
            if(window.location.pathname.indexOf('/pages/') == 0){
              active = "diamond";
            }else if (window.location.pathname.indexOf('/products/') == 0 || window.location.pathname.indexOf('/collections/') == 0) {
              active = "setting";
            }            
            changeStepFlow();
            setStepDetails(active);
        }
      }

      setTimeout(function() {
        $(".tps-step-icon").removeClass('tps-step-icon-loader');
      }, 150);
  });
/**** set steps and render steps data end *****/

/*** Change Steps For Start With Setting Slow Start ***/
function changeStepFlow() {   
   $(".tps-step-block-1 .tps-step-icon").removeClass('tps-step-icon-diamond').addClass('tps-step-icon-setting');
   $(".tps-step-block-2 .tps-step-icon").removeClass('tps-step-icon-setting').addClass('tps-step-icon-diamond');
   $(".tps-step-icon").removeClass('tps-step-icon-loader');

   if(jQuery(window).width() <= 767){
     $(".tps-step-block-1 .tps-step-title").html(translations.titleSetting);
     $(".tps-step-block-2 .tps-step-title").html(translations.titleDiamonds);
   }else{    
     $(".tps-step-block-1 .tps-step-title").html(translations.titleChooseSetting);
     $(".tps-step-block-2 .tps-step-title").html(translations.titleChooseDiamond);
   }
     
}
/*** Change Steps For Start With Setting Slow End ***/

/*** Set Selected Product Info In Steps Start ***/
function setStepDetails(active) {
  var session_steps = localStorage.getItem("ringbuilder-steps");
  session_steps = JSON.parse(session_steps);
  
  var ring_selected_diamond = localStorage.getItem("ring-selected-diamond"); 
  var ring_selected_setting = localStorage.getItem("ring-selected-setting");   
  var diamond_info = JSON.parse(ring_selected_diamond);
  var setting_info = JSON.parse(ring_selected_setting); 
  
  if(active == 'diamond' && session_steps[0]['step2'] == 'diamond'){  
    $(".tps-step-block-2").addClass('active');
  }else if(active == 'setting' && session_steps[0]['step2'] == 'setting'){ 
    $(".tps-step-block-2").addClass('active');
  }
   
  if(ring_selected_diamond){
    if(session_steps[0]['step1'] == 'diamond'){
      var step_position = '1';
    }else if(session_steps[0]['step2'] == 'diamond'){
      var step_position = '2';
    }
    
    var product_id = diamond_info[0].diamond_id;
    var product_price = diamond_info[0].diamond_formatted_price;    
    var product_url = tps_config.urls.loose_diamond_detail+'?diamond_id='+product_id+'&diamond_type='+diamond_info[0].diamond_type;
    var product_image = diamond_info[0].diamond_image;
    var product_title = diamond_info[0].diamond_title;  

    var stepProductInfoHtml = getStepsProductHtmlLayout('diamond',product_title,product_price,product_image,product_url);
    $(".tps-step-block-"+step_position+" .tps-step-product-info").html(stepProductInfoHtml);

    var stepsProductChange = '<a href="'+product_url+'" alt="'+product_title+'" title="'+product_title+'">'+translations.titleChange+'</a>';
    $(".tps-step-block-"+step_position+" .tps-step-product-change-info").html(stepsProductChange);

    // var step_product_image = '<img class="tps-step-product-image" src="'+product_image+'" title="'+product_title+'" alt="'+product_title+'" height="50" width="50">';
    // $(".tps-step-block-"+step_position+" .tps-step-icon").hide();
    // $(".tps-step-block-"+step_position+" .tps-step-image").show();
    // $(".tps-step-block-"+step_position+" .tps-step-image").html(step_product_image); 
  }
 
  if(ring_selected_setting){
    if(session_steps[0]['step1'] == 'setting'){
      var step_position = '1';
    }else if(session_steps[0]['step2'] == 'setting'){
      var step_position = '2';
    }
    var product_id = setting_info[0].product_id;
    var product_price = setting_info[0].setting_formatted_price;    
    var product_url = setting_info[0].product_url;
    var product_image = setting_info[0].setting_image;
    var product_title = setting_info[0].product_title;  

    var stepProductInfoHtml = getStepsProductHtmlLayout('setting',product_title,product_price,product_image,product_url);
    $(".tps-step-block-"+step_position+" .tps-step-product-info").html(stepProductInfoHtml);

    var stepsProductChange = '<a href="'+product_url+'" alt="'+product_title+'" title="'+product_title+'">'+translations.titleChange+'</a>';
    $(".tps-step-block-"+step_position+" .tps-step-product-change-info").html(stepsProductChange);

    // var step_product_image = '<img class="tps-step-product-image" src="'+product_image+'" title="'+product_title+'" alt="'+product_title+'" height="50" width="50">';
    // $(".tps-step-block-"+step_position+" .tps-step-icon").hide();
    // $(".tps-step-block-"+step_position+" .tps-step-image").show();
    // $(".tps-step-block-"+step_position+" .tps-step-image").html(step_product_image); 
  }

  if(ring_selected_setting && ring_selected_diamond) {
    $(".tps-step-block").addClass('active');
    
    var product_price = getFinalProductPrice();
    var diamond_id = diamond_info[0].diamond_id;
    var product_handle = setting_info[0].product_handle;
    var setting_id = setting_info[0].setting_id;
    var diamond_type = diamond_info[0].diamond_type;
    var product_url = tps_config.urls.final_ring+'?setting_select=true&diamond_select=true?products='+diamond_id+'/'+product_handle+'/'+setting_id+'/'+diamond_type;
    var product_image = setting_info[0].setting_image;
    var product_title = setting_info[0].product_title+" With "+diamond_info[0].diamond_title;

    var stepProductInfoHtml = getStepsProductHtmlLayout('final',product_title,product_price,product_image,product_url);
    $(".tps-step-block-3 .tps-step-product-info").html(stepProductInfoHtml);

    var stepsProductChange = '<span onclick="resetRing(`'+session_steps[0]['step1']+'`);">'+translations.titleReset+'</span>';
    $(".tps-step-block-3 .tps-step-product-change-info").html(stepsProductChange);

    // var step_product_image = '<img class="tps-step-product-image" src="'+product_image+'" title="'+product_title+'" alt="'+product_title+'" height="60" width="60">';
    // $(".tps-step-block-3 .tps-step-icon").hide();
    // $(".tps-step-block-3 .tps-step-image").show();
    // $(".tps-step-block-3 .tps-step-image").html(step_product_image); 
  }
}
/*** Set Selected Product Info In Steps End ***/

/*** Get Steps Product View Layout Start ***/
function getStepsProductHtmlLayout(action,product_title,product_price,product_image,product_url) {
  var session_steps = localStorage.getItem("ringbuilder-steps");
  session_steps = JSON.parse(session_steps);
  
  var stepProductInfoHtml = '';
  stepProductInfoHtml += '<div class="tps-step-block-steps-info-wrapper">';
  stepProductInfoHtml += '<div class="tps-step-block-steps-info-img">';
  stepProductInfoHtml += '<img src="'+product_image+'" title="'+product_title+'" alt="'+product_title+'">';
  stepProductInfoHtml += '</div>';
  stepProductInfoHtml += '<div class=tps-step-block-steps-info-content>';
  stepProductInfoHtml += '<span class="tps-step-block-steps-info-title">'+product_title+'</span>';
  stepProductInfoHtml += '<span class="tps-step-block-steps-info-prise">'+product_price+'</span>';
  stepProductInfoHtml += '<span class="tps-step-block-steps-info-view-remove">';
  stepProductInfoHtml += '<a href="'+product_url+'" rel="nofollow" class="">'+translations.titleView+'</a>';
  if(action == 'final'){
    stepProductInfoHtml += '<span class="" onclick="resetRing(`'+session_steps[0]['step1']+'`);">'+translations.titleReset+'</span>';
  }else{
    stepProductInfoHtml += '<span class="" onclick="removeProduct(`'+action+'`);">'+translations.titleRemove+'</span>';
  }  
  
  stepProductInfoHtml += '</span>';
  stepProductInfoHtml += '</div>';
  stepProductInfoHtml += '</div>';
  return stepProductInfoHtml;
}
/*** Get Steps Product View Layout End ***/

/*** Remove Product From RingBuilder Flow Start ***/
function removeProduct(action) {
  localStorage.removeItem("ring-selected-"+action);
  if(action == 'setting'){
      window.location.href = tps_config.urls.setting_listing+"";
  }else{
      window.location.href = tps_config.urls.loose_diamond+"";
  }
}
/*** Remove Product From RingBuilder Flow End ***/

/**** Ring Builder Flow Reset Start *****/
function resetRing(step){
  let message = translations.titleResetRing;
  if (confirm(message) == true) {
    localStorage.clear();  
    if(step == 'setting'){
        window.location.href = tps_config.urls.setting_listing+"";
    }else{
        window.location.href = tps_config.urls.loose_diamond+"";
    }
  } else {
    return false;
  } 
}
/**** Ring Builder Flow Reset End *****/

/*** Get Final Ring Product Price Start ***/
function getFinalProductPrice(){
  var setting_info = JSON.parse(localStorage.getItem("ring-selected-setting"));  
  var diamond_info = JSON.parse(localStorage.getItem("ring-selected-diamond"));

  var setting_price = setting_info[0].setting_price/100;
  var diamond_price = diamond_info[0].diamond_price;

  var final_price = parseInt(setting_price)+parseInt(diamond_price);
  final_price = getPriceWithCurrencySymbol(final_price);
  return final_price;
}

function getPriceWithCurrencySymbol(price){
  price = Shopify.formatMoney(price*100,theme.moneyFormat);
  return price;
}